import { object as yupObject, string as yupString, boolean as yupBool } from 'yup';
import 'yup_extensions';
import validationMessages from 'components/accountant_leads/lead_form_validation_message';
import { jQueryMaskRegexOrEmptyString, loginBaseUrl, urlRegex } from 'constants/lead_form_utils';
import { trackMessageFromExistingUser } from 'components/survey_signup_modal/tracking_helpers';

const {
  firstNameMessage,
  lastNameMessage,
  emailMessage,
  firmMessage,
  websiteMessage,
  numberCompaniesMessage,
  numberPayrollCompaniesMessage,
  phoneMessage,
  phoneLengthMessage,
  termsAcceptanceMessage,
  uniqueEmailMessage,
} = validationMessages;

const emailSchema = yupString().email(emailMessage).required(emailMessage);

export const uniqueEmailSchema = api =>
  yupString().test('unique-email', uniqueEmailMessage(loginBaseUrl), async email => {
    const validEmail = await emailSchema.isValid(email);
    if (validEmail) {
      return api('/invite/existing-user-email-lookup', { email })
        .then(isTaken => {
          if (isTaken) {
            trackMessageFromExistingUser('accountant');
          }
          return !isTaken;
        })
        .catch(() => true);
    }
    return true;
  });

export default (showAccountantTermsField = false) =>
  yupObject().shape({
    accountant_lead: yupObject().shape({
      first_name: yupString()
        .matches(/^[A-zÀ-ú]+/, firstNameMessage)
        .required(firstNameMessage),
      last_name: yupString()
        .matches(/^[A-zÀ-ú]+/, lastNameMessage)
        .required(lastNameMessage),
      accounting_firm_name: yupString()
        .min(2, firmMessage)
        .required(firmMessage)
        .noEmailValue('Please remove invalid characters.'),
      email: yupString().email(emailMessage).required(emailMessage),
      website: yupString().matches(urlRegex, websiteMessage),
      number_companies_bucket: yupString().required(numberCompaniesMessage),
      number_payroll_services_clients_bucket: yupString().required(numberPayrollCompaniesMessage),
      phone: yupString()
        .matches(jQueryMaskRegexOrEmptyString, phoneLengthMessage)
        .required(phoneMessage),
    }),
    terms_acceptance: yupBool().when([], {
      is: () => showAccountantTermsField,
      then: schema => schema.oneOf([true], termsAcceptanceMessage),
      otherwise: schema => schema,
    }),
  });
